<template>
  <div class="user_category" :key="this.$route.path">
    <div class="table_card mb-5">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg9 class="head_contain">
            <p class="table_card__head--title">Información General</p>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-1">
              <button
                class="faccess_button px-5"
                @click="
                  userCategoryId
                    ? (show_confirm_modal = true)
                    : createUserCategory()
                "
                :disabled="name.length < 2"
              >
                {{ userCategoryId ? "Editar plan" : "Crear plan" }}
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 lg6 class="pr-3">
            <label
              class="table_card__info--label"
              :class="{ 'custom_input__title--colapsed': name != '' }"
            >
              Nombre:
            </label>
            <input
              class="faccess_input"
              :class="{ 'custom_input__inputs--open': name != '' }"
              type="text"
              v-model="name"
            />
          </v-flex>
          <v-flex xs12 lg6 class="pl-3">
            <label
              class="table_card__info--label"
              :class="{ 'custom_input__title--colapsed': description != '' }"
            >
              Descripción:
            </label>
            <input
              class="faccess_input"
              :class="{ 'custom_input__inputs--open': description != '' }"
              type="text"
              v-model="description"
            />
          </v-flex>

          <v-flex xs12 lg6 class="pl-3">
            <v-switch
              class="data_card__switch"
              :label="'Limitar cantidad de accesos por día'"
              v-model="activate_access_limit_quantity"
              color="#1476FB"
            ></v-switch>
          </v-flex>
          <v-flex xs12 lg6 class="pl-3" v-show="activate_access_limit_quantity">
            <span class="table_card__info--label"
              >Máximo de accesos diarios por usuario</span
            >
            <div class="data_card__counter justified">
              <div class="justified__container">
                <button
                  class="faccess_counter__button"
                  @click="
                    access_limit_quantity > 1 ? access_limit_quantity-- : 1
                  "
                >
                  <img src="@/assets/img/icons/icono-menos.svg" />
                </button>
                <input
                  class="faccess_counter__input"
                  type="number"
                  name="Name"
                  :value="access_limit_quantity"
                  readonly
                />
                <button
                  class="faccess_counter__button"
                  @click="access_limit_quantity++"
                >
                  <img src="@/assets/img/icons/icono-mas.svg" />
                </button>
              </div>
            </div>
          </v-flex>
          <v-flex
            xs12
            lg6
            class="pl-3"
            v-if="getCompany().access.notify_access"
          >
            <v-switch
              class="data_card__switch"
              :label="'Notificar accesos'"
              v-model="report_access"
              color="#1476FB"
            ></v-switch>
          </v-flex>
          <v-flex xs12 lg6 class="pl-3">
            <v-switch
              class="data_card__switch"
              :label="'Enviar Invitación'"
              v-model="send_invitation"
              color="#1476FB"
            ></v-switch>
          </v-flex>
          <v-flex xs12 lg6 class="pl-3" v-if="getCompany().directory">
            <v-switch
              class="data_card__switch"
              :label="'Incluir en directorio'"
              v-model="add_to_directory"
              color="#1476FB"
            ></v-switch>
          </v-flex>
          <v-flex
            xs12
            lg6
            class="pl-3"
            v-if="getCompany().access.remote_open_door"
          >
            <v-switch
              class="data_card__switch"
              :label="'Apertura remota de puertas'"
              v-model="remote_open_door"
              color="#1476FB"
            ></v-switch>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div class="table_card">
      <div class="table_card__head">
        <p class="table_card__head--title">
          Sedes del plan
        </p>
      </div>
      <div class="table_card__body" style="padding-bottom: 12px;">
        <v-checkbox
          v-for="location in available_locations"
          :key="location.location_id"
          v-model="location_selected"
          :label="location.name"
          :value="location.location_id"
          color="#1476FB"
          style="margin-top: 0px !important; padding-top: 0px !important"
        ></v-checkbox>
      </div>

      <div class="table_card__footer justify-content-start">
        <nav class="pagination" role="navegation" aria-label="pagination">
          <v-pagination :value="page" :length="pages" @input="changePage" />
        </nav>
      </div>
    </div>

    <section v-if="show_confirm_modal" class="access_devices__modal">
      <section class="access_devices__modal--container" style="width: 40%;">
        <p class="access_devices__modal--text" style="text-align: justify;">
          <b>AVISO:</b> Si las <b>sedes del plan</b> fueron cambiadas, los
          usuarios del plan serán <b>desvinculados</b> de las locaciones a las
          que esten relacionados.
        </p>
        <br />
        <p class="access_devices__modal--text">
          ¿Está seguro de editar el plan de usuario?
        </p>
        <div class="access_devices__modal--buttons" style="margin-top: 1rem;">
          <div
            class="access_devices__modal--button"
            @click="show_confirm_modal = false"
          >
            Cancelar
          </div>
          <div
            class="access_devices__modal--button active"
            @click="updateUserCategory"
          >
            Si
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  props: ["userCategoryId"],
  data() {
    return {
      available_locations: [],
      location_selected: [],
      name: "",
      description: "",
      send_invitation: false,
      add_to_directory: false,
      activate_access_limit_quantity: false,
      report_access: false,
      remote_open_door: false,
      access_limit_quantity: 0,
      page: 1,
      pages: 1,
      show_confirm_modal: false
    };
  },
  watch: {
    userCategoryId: function(newVal) {
      if (newVal) {
        this.getUserCategory();
      } else {
        this.name = "";
        this.description = "";
        this.location_selected = [];
        this.send_invitation = false;
        this.add_to_directory = false;
        this.access_limit_quantity = 0;
        this.report_access = false;
      }
    },
    activate_access_limit_quantity(val) {
      if (val == false) {
        this.access_limit_quantity = 0;
      } else if (
        this.access_limit_quantity === 0 ||
        this.access_limit_quantity === null
      ) {
        this.access_limit_quantity = 1;
      }
    }
  },
  methods: {
    getLocations() {
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .post(
            "locations/company",
            {
              data: this.encrypt(data).toString(),
              page: this.page
            },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken()
              }
            }
          )
          .then(function(response) {
            this.sortAvailableLocations(response.body);
            this.pages = response.body.meta.pages;
          });
      } catch (e) {
        alert(e);
      }
    },
    sortAvailableLocations(dataResponse) {
      this.available_locations = [];
      for (var i = 0; i < dataResponse.data.length; i++) {
        if (dataResponse.data[i].attributes.published == true) {
          this.available_locations.push({
            location_id: parseInt(dataResponse.data[i].id),
            name: dataResponse.data[i].attributes.name
          });
        }
      }
    },
    getUserCategory() {
      let params = {
        id: this.userCategoryId,
        company_id: this.getCompany().id
      };
      try {
        this.$http
          .get("user_categories/show", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params
          })
          .then(function(response) {
            let {
              name,
              description,
              send_invitation,
              add_to_directory,
              report_access,
              access_doors,
              access_limit_quantity,
              remote_open_door
            } = response.body;

            this.name = name;
            this.description = description;
            this.location_selected = access_doors;
            this.send_invitation = send_invitation;
            this.add_to_directory = add_to_directory;
            this.report_access = report_access;
            this.remote_open_door = remote_open_door;
            this.access_limit_quantity =
              access_limit_quantity !== null && access_limit_quantity > 0
                ? access_limit_quantity
                : 0;
            this.activate_access_limit_quantity =
              access_limit_quantity !== null && access_limit_quantity > 0
                ? true
                : false;
          });
      } catch (e) {
        alert(e);
      }
    },
    createUserCategory() {
      let data = {
        name: this.name,
        description: this.description,
        access_doors: this.location_selected,
        send_invitation: this.send_invitation,
        add_to_directory: this.add_to_directory,
        report_access: this.report_access,
        access_limit_quantity: this.access_limit_quantity,
        company_id: this.getCompany().id,
        remote_open_door: this.remote_open_door
      };
      this.$http
        .post(
          "user_categories/create",
          { data: this.encrypt(data).toString() },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            }
          }
        )
        .then(function(response) {
          this.updateAlertMessage("Plan de usuario creado satisfactoriamente");
          this.updateIsInAlert(true);
          this.$router.push({ name: "user_list_plans" });
        })
        .catch(function(response) {
          this.updateAlertMessage(response.body.errors[0].title);
          this.updateIsInAlert(true);
        });
    },
    updateUserCategory() {
      let data = {
        name: this.name,
        description: this.description,
        access_doors: this.location_selected,
        send_invitation: this.send_invitation,
        add_to_directory: this.add_to_directory,
        report_access: this.report_access,
        access_limit_quantity: this.access_limit_quantity,
        company_id: this.getCompany().id,
        remote_open_door: this.remote_open_door
      };
      console.log(data);
      this.$http
        .put(
          "user_categories/update",
          { data: this.encrypt(data).toString(), id: this.userCategoryId },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            }
          }
        )
        .then(function(response) {
          this.updateAlertMessage(
            "Plan de usuario actualizado satisfactoriamente"
          );
          this.updateIsInAlert(true);
          this.$router.push({ name: "user_list_plans" });
        })
        .catch(function(response) {
          this.updateAlertMessage(response.body.errors[0].title);
          this.updateIsInAlert(true);
        });

      this.show_confirm_modal = false;
    },
    changePage(page) {
      this.page = page;
      this.getLocations();
    }
  },
  mounted() {
    this.getLocations();
    console.log(this.getCompany());
    this.userCategoryId ? this.getUserCategory() : null;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/access/UserCategory.vue